import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Select, Button, Form } from "antd";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { retryFailedEnvelopeSchema } from "../../schema/envelope.schema";

const { Option } = Select;

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 8 },
};
const formItemLayoutWithOutLabel = {
  wrapperCol: {
    xs: { span: 8, offset: 6 },
    sm: { span: 8, offset: 6 },
  },
};

const STATUS_OPTIONS = [
  { label: "FAILED_DOWNLOAD", value: "FAILED_DOWNLOAD" },
  { label: "FAILED_UPLOAD", value: "FAILED_UPLOAD" },
];

const FailedEnvelopRetry = (props) => {
  const { filteredRecords, resendData } = props;
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(retryFailedEnvelopeSchema),
  });
  const watchStatus = watch("status");

  useEffect(() => {
    reset();
  }, [filteredRecords]);

  return (
    <>
      <Form.Item
        {...formItemLayout}
        label="Status"
        help={errors?.status?.message}
        validateStatus={errors?.status ? "error" : ""}
        required
      >
        <Controller
          name="status"
          control={control}
          render={({ field: { onChange, onBlur, value } }) => (
            <Select
              placeholder="Please Select"
              style={{ width: "100%" }}
              options={STATUS_OPTIONS}
              onBlur={onBlur}
              onChange={(e) => {
                onChange(e);
                setValue("id", undefined);
              }}
              value={value}
            />
          )}
        />
      </Form.Item>
      <Form.Item
        {...formItemLayout}
        label="Rev ID"
        help={errors?.id?.message}
        validateStatus={errors?.id ? "error" : ""}
        required
      >
        <Controller
          name="id"
          control={control}
          render={({ field }) => (
            <Select placeholder="Please Select" {...field}>
              {filteredRecords
                .filter((record) => record.status === watchStatus)
                .map((envelope) => (
                  <Option key={envelope.Id} value={envelope.Id}>
                    {envelope.Id}
                  </Option>
                ))}
            </Select>
          )}
        />
      </Form.Item>
      <Form.Item {...formItemLayoutWithOutLabel}>
        <Button onClick={handleSubmit(resendData)} style={{ width: "100%" }}>
          Resend
        </Button>
      </Form.Item>
    </>
  );
};

FailedEnvelopRetry.propTypes = {
  filteredRecords: PropTypes.arrayOf(
    PropTypes.shape({
      Id: PropTypes.number.isRequired,
      status: PropTypes.string.isRequired,
    }),
  ).isRequired,
  resendData: PropTypes.func.isRequired,
};

export default FailedEnvelopRetry;
